export default __webpack_public_path__ + "static/media/balt2022.b911c79b.mp4";